// import React from 'react';
// import { useNavigate } from 'react-router-dom';


// function HomePage() {

//   let navigate = useNavigate();
//   return (
//     <>
//     <div style={{background:"white" , padding:"20px" , width : "100%", color: "blue", textAlign: "center", textDecoration: "underline", cursor: "pointer"}} onClick={() => navigate("/visa/listing")}> Click here to Redirect "Result Page".</div>
//     </>
//   )
// }

// export default HomePage

import React from "react";
import homepageData from "../../../VisaData/VisasListing.json";
import SearchBar from "./SearchBar/SearchBar";
// import PendingApplications from "./PendingApplications/PendingApplications";
// import VisaListingSection from "./VisaListingSection/VisaListingSection";
// import GuestReviewsSection from "./GuestReviewsSection/GuestReviewsSection";

export default function HomePage() {
  return (
    <div className="homepage-root">
      <div className="searchbar">
        <div className="width-container">
          <SearchBar 
            visaCountries={homepageData.visaCountries} 
            calendarMonths={homepageData.calendarMonths} 
          />
        </div>
        <div className="width-container">
          {/* <PendingApplications applications={homepageData.pendingApplications} /> */}
        </div>
      </div>

      <section className="visalistingwrapper">
        <div className="width-container">
          {/* <VisaListingSection countries={homepageData.visaCountries} />
          <GuestReviewsSection reviews={homepageData.guestReviews} /> */}
        </div>
      </section>
    </div>
  );
}